import { handleActions, combineActions } from 'redux-actions'
import types from './types'

const INITIAL_STATE = {
  isLoading: true,
  data: {
    activeNoticesSubscriptions: [],
    historyNoticesSubscriptions: [],
  },
}

const beginLoading = combineActions(types.LOAD_MY_SUBSCRIPTIONS)

const stopLoading = combineActions(
  types.LOAD_MY_SUBSCRIPTIONS_SUCCESS,
  types.LOAD_MY_SUBSCRIPTIONS_FAIL
)

const reducer = handleActions(
  {
    [beginLoading]: (state) => ({
      ...state,
      isLoading: true,
    }),
    [stopLoading]: (state) => ({
      ...state,
      isLoading: false,
    }),
    [types.LOAD_MY_SUBSCRIPTIONS_SUCCESS]: (
      state,
      {
        payload: {
          data: { data },
        },
      }
    ) => ({
      ...state,
      data,
    }),
    [types.CLEAR_STATE]: () => INITIAL_STATE,
  },
  INITIAL_STATE
)

export default reducer
